import type { AppDispatch, RootState } from "@src/store/rootState";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import {
  markNewVisualBuilderMod,
  setOnsiteEdits,
} from "@src/store/slices/onsiteEdits";
import { setOnsiteInjections } from "@src/store/slices/onsiteInjections";
import { setComponents } from "@src/store/slices/experienceComponents";
import { getConvertedMods } from "@src/store/slices/experienceBuilder/common/selectors/getConvertedMods";

/**
 * Saves the current mods to the onsite edits, injections, and components slices.
 * This is the shared save logic used by both saveBuilder and closeBuilder.
 */
export const saveMods = (dispatch: AppDispatch, getState: () => RootState) => {
  const { onsiteEdits, onsiteInjections, components } =
    getConvertedMods(getState());

  // Check if VB is introducing new edits that don't exist in storedEdits
  const storedEdits = getState().onsiteEdits.storedEdits;
  const storedIds = new Set(storedEdits.map((e) => e.id));
  if (onsiteEdits.some((e) => !storedIds.has(e.id))) {
    dispatch(markNewVisualBuilderMod());
  }

  dispatch(setOnsiteEdits(onsiteEdits));
  dispatch(setOnsiteInjections(onsiteInjections));
  dispatch(setComponents(components));
  dispatch(experienceBuilderSlice.actions.commitBuilderMods());
};
